import React from "react";
import {
  AButton,
  AButtonGroup,
  ACol,
  AContainer,
  ARow,
  useATheme
} from "@cisco-sbg-ui/magna-react";
import useDevelopmentMode from "./hooks/useDevelopmentMode";

export default function DevTools() {
  const {currentTheme, setCurrentTheme} = useATheme();
  const {isAppInStandaloneMode} = useDevelopmentMode();

  return (
    isAppInStandaloneMode && (
      <AContainer fluid className="py-0">
        <ARow>
          <ACol xs="12">
            <AButtonGroup
              selectedValues={[currentTheme]}
              onChange={(value) => setCurrentTheme(value)}>
              <AButton medium value="default">
                Light
              </AButton>
              <AButton medium value="dusk">
                Dark
              </AButton>
            </AButtonGroup>
          </ACol>
        </ARow>
      </AContainer>
    )
  );
}
